import { SVGProps } from 'react';

const UserRoundPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 21a8 8 0 0 1 13.292-6M19 16v6m3-3h-6M15 8A5 5 0 1 1 5 8a5 5 0 0 1 10 0"
    />
  </svg>
);
export default UserRoundPlus;
